//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetUsersUserQueryParameters = {
  search?: string | null | undefined ;
}

export type ChangePasswordByAdminUserQueryParameters = {
  id: string ;
}

export type EditUserUserQueryParameters = {
  id: string ;
}

export type RemoveUserUserQueryParameters = {
  id: string ;
}

export type GetUserUserQueryParameters = {
  id: string ;
}

export type LockUserUserQueryParameters = {
  id: string ;
}

export type UnlockUserUserQueryParameters = {
  id: string ;
}

export function getUsersUrl(search?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/users?";
if (search !== undefined && search !== null)
    url_ += "search=" + encodeURIComponent("" + search) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUsersDefaultOptions: Omit<UseQueryOptions<Types.UserDto[], unknown, Types.UserDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserDto[], unknown, Types.UserDto[]>, 'queryFn'>> = {
};
export function getGetUsersDefaultOptions() {
  return getUsersDefaultOptions;
};
export function setGetUsersDefaultOptions(options: typeof getUsersDefaultOptions) {
  getUsersDefaultOptions = options;
}

export function getUsersQueryKey(search?: string | null | undefined): QueryKey;
export function getUsersQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search,  } = params[0] as GetUsersUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'getUsers',
        search as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'getUsers',
        ...params
      ]);
  }
}
export function __getUsers(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUsers(
      context.queryKey[2] as string | null | undefined,axiosConfig    );
}

export function useGetUsersQuery<TSelectData = Types.UserDto[], TError = unknown>(dto: GetUsersUserQueryParameters, options?: Omit<UseQueryOptions<Types.UserDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all users.
 * @param search (optional) The query to search the users
 */
export function useGetUsersQuery<TSelectData = Types.UserDto[], TError = unknown>(search?: string | null | undefined, options?: Omit<UseQueryOptions<Types.UserDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUsersQuery<TSelectData = Types.UserDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search,  } = params[0] as GetUsersUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUsers(context, axiosConfig) : __getUsers,
    queryKey: getUsersQueryKey(search),
    ...getUsersDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all users.
 * @param search (optional) The query to search the users
 */
export function setGetUsersData(queryClient: QueryClient, updater: (data: Types.UserDto[] | undefined) => Types.UserDto[], search?: string | null | undefined) {
  queryClient.setQueryData(getUsersQueryKey(search),
    updater
  );
}

/**
 * Gets all users.
 * @param search (optional) The query to search the users
 */
export function setGetUsersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserDto[] | undefined) => Types.UserDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function changePasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/users";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changePasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'changePassword',
    ]);
}

/**
 * Changes password by a user.
 * @param dto The dto contains old and new passwords.
 */
export function useChangePasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ChangePasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ChangePasswordDto, TContext> {
  const key = changePasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ChangePasswordDto) => Client.changePassword(dto),
    mutationKey: key,
  });
}
  
export function createUserUrl(): string {
  let url_ = getBaseUrl() + "/api/users";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createUserMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'createUser',
    ]);
}

/**
 * Creates a user by admin of some Tenant.
Automatically adds the user to a Subtenant.
 * @param dto Request parameter
 */
export function useCreateUserMutation<TContext>(options?: Omit<UseMutationOptions<Types.UserDto, unknown, Types.CreateUserByAdminDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.UserDto, unknown, Types.CreateUserByAdminDto, TContext> {
  const key = createUserMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateUserByAdminDto) => Client.createUser(dto),
    mutationKey: key,
  });
}
  
export function changePasswordByAdminUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}/password";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changePasswordByAdminMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'changePasswordByAdmin',
      id as any,
    ]);
}

/**
 * Changes password for a user.
 * @param id The user id.
 * @param dto The dto contains password.
 */
export function useChangePasswordByAdminMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, Types.CreatePasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreatePasswordDto, TContext> {
  const key = changePasswordByAdminMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreatePasswordDto) => Client.changePasswordByAdmin(id, dto),
    mutationKey: key,
  });
}
  
type ChangePasswordByAdmin__MutationParameters = ChangePasswordByAdminUserQueryParameters & {
  dto: Types.CreatePasswordDto;
}

/**
 * Changes password for a user.
 * @param id The user id.
 * @param dto The dto contains password.
 */
export function useChangePasswordByAdminMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ChangePasswordByAdmin__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ChangePasswordByAdminUserQueryParameters}): UseMutationResult<void, unknown, ChangePasswordByAdmin__MutationParameters, TContext> {
  const key = changePasswordByAdminMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ChangePasswordByAdmin__MutationParameters) => Client.changePasswordByAdmin(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function resetPasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/users/reset-password";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetPasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'resetPassword',
    ]);
}

/**
 * Allows user to reset their password using single-use password reset token issued by the backend.
 */
export function useResetPasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ResetPasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ResetPasswordDto, TContext> {
  const key = resetPasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ResetPasswordDto) => Client.resetPassword(dto),
    mutationKey: key,
  });
}
  
export function editUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'editUser',
      id as any,
    ]);
}

/**
 * Edits a user. This should only be accessible by ADMINs, since it changes roles and Subtenants
 * @param id The user id.
 * @param dto Request parameter.
 */
export function useEditUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateUserDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateUserDto, TContext> {
  const key = editUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateUserDto) => Client.editUser(id, dto),
    mutationKey: key,
  });
}
  
type EditUser__MutationParameters = EditUserUserQueryParameters & {
  dto: Types.UpdateUserDto;
}

/**
 * Edits a user. This should only be accessible by ADMINs, since it changes roles and Subtenants
 * @param id The user id.
 * @param dto Request parameter.
 */
export function useEditUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditUserUserQueryParameters}): UseMutationResult<void, unknown, EditUser__MutationParameters, TContext> {
  const key = editUserMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditUser__MutationParameters) => Client.editUser(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'removeUser',
      id as any,
    ]);
}

/**
 * Removes a user.
 * @param id The user id.
 */
export function useRemoveUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeUser(id),
    mutationKey: key,
  });
}
  
type RemoveUser__MutationParameters = RemoveUserUserQueryParameters

/**
 * Removes a user.
 * @param id The user id.
 */
export function useRemoveUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveUserUserQueryParameters}): UseMutationResult<void, unknown, RemoveUser__MutationParameters, TContext> {
  const key = removeUserMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveUser__MutationParameters) => Client.removeUser(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUserDefaultOptions: Omit<UseQueryOptions<Types.UserDto, unknown, Types.UserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserDto, unknown, Types.UserDto>, 'queryFn'>> = {
};
export function getGetUserDefaultOptions() {
  return getUserDefaultOptions;
};
export function setGetUserDefaultOptions(options: typeof getUserDefaultOptions) {
  getUserDefaultOptions = options;
}

export function getUserQueryKey(id: string): QueryKey;
export function getUserQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetUserUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'getUser',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'getUser',
        ...params
      ]);
  }
}
export function __getUser(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUser(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetUserQuery<TSelectData = Types.UserDto, TError = unknown>(dto: GetUserUserQueryParameters, options?: Omit<UseQueryOptions<Types.UserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a user by id.
 * @param id The user id.
 */
export function useGetUserQuery<TSelectData = Types.UserDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.UserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUserQuery<TSelectData = Types.UserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetUserUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUser(context, axiosConfig) : __getUser,
    queryKey: getUserQueryKey(id),
    ...getUserDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a user by id.
 * @param id The user id.
 */
export function setGetUserData(queryClient: QueryClient, updater: (data: Types.UserDto | undefined) => Types.UserDto, id: string) {
  queryClient.setQueryData(getUserQueryKey(id),
    updater
  );
}

/**
 * Gets a user by id.
 * @param id The user id.
 */
export function setGetUserDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserDto | undefined) => Types.UserDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function lockUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}/lock";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function lockUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'lockUser',
      id as any,
    ]);
}

/**
 * Locks a user.
 * @param id The user id.
 */
export function useLockUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = lockUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.lockUser(id),
    mutationKey: key,
  });
}
  
type LockUser__MutationParameters = LockUserUserQueryParameters

/**
 * Locks a user.
 * @param id The user id.
 */
export function useLockUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, LockUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: LockUserUserQueryParameters}): UseMutationResult<void, unknown, LockUser__MutationParameters, TContext> {
  const key = lockUserMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: LockUser__MutationParameters) => Client.lockUser(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function unlockUserUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/users/{id}/unlock";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function unlockUserMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'unlockUser',
      id as any,
    ]);
}

/**
 * Unlocks a user.
 * @param id The user id.
 */
export function useUnlockUserMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = unlockUserMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.unlockUser(id),
    mutationKey: key,
  });
}
  
type UnlockUser__MutationParameters = UnlockUserUserQueryParameters

/**
 * Unlocks a user.
 * @param id The user id.
 */
export function useUnlockUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UnlockUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UnlockUserUserQueryParameters}): UseMutationResult<void, unknown, UnlockUser__MutationParameters, TContext> {
  const key = unlockUserMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UnlockUser__MutationParameters) => Client.unlockUser(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getCurrentUserInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/users/me";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCurrentUserInfoDefaultOptions: Omit<UseQueryOptions<Types.CurrentUserDto, unknown, Types.CurrentUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CurrentUserDto, unknown, Types.CurrentUserDto>, 'queryFn'>> = {
};
export function getGetCurrentUserInfoDefaultOptions() {
  return getCurrentUserInfoDefaultOptions;
};
export function setGetCurrentUserInfoDefaultOptions(options: typeof getCurrentUserInfoDefaultOptions) {
  getCurrentUserInfoDefaultOptions = options;
}

export function getCurrentUserInfoQueryKey(): QueryKey;
export function getCurrentUserInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserClient',
      'getCurrentUserInfo',
    ]);
}
export function __getCurrentUserInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCurrentUserInfo(
axiosConfig    );
}

/**
 * Gets permissions for the current user
 */
export function useGetCurrentUserInfoQuery<TSelectData = Types.CurrentUserDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.CurrentUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCurrentUserInfoQuery<TSelectData = Types.CurrentUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CurrentUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CurrentUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCurrentUserInfo(context, axiosConfig) : __getCurrentUserInfo,
    queryKey: getCurrentUserInfoQueryKey(),
    ...getCurrentUserInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.CurrentUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets permissions for the current user
 */
export function setGetCurrentUserInfoData(queryClient: QueryClient, updater: (data: Types.CurrentUserDto | undefined) => Types.CurrentUserDto, ) {
  queryClient.setQueryData(getCurrentUserInfoQueryKey(),
    updater
  );
}

/**
 * Gets permissions for the current user
 */
export function setGetCurrentUserInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CurrentUserDto | undefined) => Types.CurrentUserDto) {
  queryClient.setQueryData(queryKey, updater);
}